import { HStack } from "native-base";

export default HStack;